import React from 'react';
import styles from './YellowExclamationIcon.module.css';
import clsx from 'clsx';

interface YellowExclamationIconProps {
  size: number;
  className?: any;
  title?: string;
}

const YellowExclamationIcon = ({ size, className, title }: YellowExclamationIconProps) => {
  return (
    <div title={title} style={{ width: size, height: size }} className={clsx(styles.bg, className)}>
      !
    </div>
  );
};

export default YellowExclamationIcon;
